/**
 * Banner vises øverst i appen når Supabase-klienten ikke peker mot
 * prod-prosjektet. Supabase Branching gir preview-branches egne
 * database-URLer som ikke inneholder prod-prosjekt-IDen, så dette er
 * en pålitelig proxy for "testmiljø".
 *
 * VIB-524: reduserer risikoen for at en utvikler eller selger antar at
 * de sitter i prod når de faktisk er i en preview-branch.
 * VIB-647: deteksjonen ligger nå i useIsTestEnvironment-hooken slik at
 * komponenten ikke importerer supabase-klienten direkte.
 */

import { useIsTestEnvironment } from "@/hooks/use-is-test-environment";

export function EnvironmentBanner() {
  const isTest = useIsTestEnvironment();
  if (!isTest) return null;

  return (
    <div className="w-full bg-amber-400 text-amber-950 text-center text-xs font-semibold tracking-wider py-1 px-3">
      TESTMILJØ — endringer påvirker ikke prod
    </div>
  );
}
